<template>
  <div class="min-h-screen">
    <main class="min-h-full">
      <!-- Header -->
      <header
        class="absolute inset-x-0 top-0 z-50 border-b bg-background/80 backdrop-blur-md [backdrop-filter:saturate(140%)_blur(14px)]"
      >
        <nav
          class="mx-auto flex h-[68px] w-full max-w-6xl items-center justify-between gap-2 px-[18px] sm:px-7"
        >
          <NuxtLink href="/" class="flex min-w-0 items-center" aria-label="DownSub">
            <ClientOnly>
              <img
                :src="$colorMode.value === 'dark' ? '/logo-light.png' : '/logo.png'"
                alt="DownSub"
                :class="brandLogoClass"
              />
              <template #fallback>
                <img src="/logo.png" alt="DownSub" :class="brandLogoClass" />
              </template>
            </ClientOnly>
          </NuxtLink>
          <div class="flex flex-none items-center gap-1 sm:gap-2">
            <LanguageToggle />
            <ThemeToggle />
            <NuxtLink
              v-if="user"
              :class="[buttonVariants(), 'whitespace-nowrap max-sm:px-3']"
              to="/dashboard"
            >
              {{ $t("common.dashboard") }}
            </NuxtLink>
            <template v-else>
              <NuxtLink
                :class="[buttonVariants({ variant: 'outline' }), 'whitespace-nowrap max-sm:px-3']"
                to="/auth"
              >
                {{ $t("landing.seo.nav.signIn") }}
              </NuxtLink>
              <!-- No drawer here, so narrow screens keep only "Sign in" -->
              <NuxtLink
                :class="[buttonVariants(), 'max-sm:hidden']"
                to="/auth?view=sign_up"
              >
                {{ $t("landing.seo.nav.startFree") }}
              </NuxtLink>
            </template>
          </div>
        </nav>
      </header>
      <slot />
    </main>
    <Toaster richColors />
  </div>
</template>

<script setup lang="ts">
import { buttonVariants } from "@/components/ui/button";
import { Toaster } from "@/components/ui/sonner";

const user = useSupabaseUser();
// Smaller than the landing logo on phones: the auth buttons stay in this bar
const brandLogoClass = "h-8 w-auto max-w-full object-contain sm:h-12";
</script>

<style scoped></style>
